import { takeLatest, put, call, all } from 'redux-saga/effects';
import LeaveAdjustmentTypes from './LeaveAdjustment.types';
import {
	getEmployeeLeaveBalance,
	createLeaveAdjustment,
} from './LeaveAdjustment.services';
import {
	getEmployeeLeaveBalanceSuccess,
	getEmployeeLeaveBalanceFailure,
	createLeaveAdjustmentSuccess,
	createLeaveAdjustmentFailure,
} from './LeaveAdjustment.actions';
import { encryptData } from '../_common/enode-decode';
import AlertManager from '../../utils/alertManager';

// ========== GET EMPLOYEE LEAVE BALANCE SAGA START ==========
export function* getEmployeeLeaveBalanceSaga(payload: any) {
	try {
		const encryptedData = encryptData(
			payload.payload,
			LeaveAdjustmentTypes.GET_EMPLOYEE_LEAVE_BALANCE_KEY,
		);
		// @ts-ignore
		const responseData = yield call(getEmployeeLeaveBalance as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'success') {
				yield put(getEmployeeLeaveBalanceSuccess(responseData.data));
			} else {
				yield put(getEmployeeLeaveBalanceFailure(responseData.data));
			}
		}
	} catch (error: any) {
		yield put(
			getEmployeeLeaveBalanceFailure(error?.response?.data?.message || 'An error occurred'),
		);
	}
}

export function* onGetEmployeeLeaveBalanceStart(): Generator<any, void, any> {
	yield takeLatest(
		LeaveAdjustmentTypes.GET_EMPLOYEE_LEAVE_BALANCE_START as any,
		getEmployeeLeaveBalanceSaga,
	);
}
// ========== GET EMPLOYEE LEAVE BALANCE SAGA END ==========

// ========== CREATE LEAVE ADJUSTMENT SAGA START ==========
export function* createLeaveAdjustmentSaga(payload: any) {
	try {
		const encryptedData = encryptData(
			payload.payload,
			LeaveAdjustmentTypes.CREATE_LEAVE_ADJUSTMENT_KEY,
		);
		// @ts-ignore
		const responseData = yield call(createLeaveAdjustment as any, encryptedData);
		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'success') {
				yield put(createLeaveAdjustmentSuccess(responseData.data));
			} else {
				yield put(createLeaveAdjustmentFailure(responseData.data));
			}
		}
	} catch (error: any) {
		yield put(
			createLeaveAdjustmentFailure(error?.response?.data?.message || 'An error occurred'),
		);
	}
}

export function* onCreateLeaveAdjustmentStart(): Generator<any, void, any> {
	yield takeLatest(
		LeaveAdjustmentTypes.CREATE_LEAVE_ADJUSTMENT_START as any,
		createLeaveAdjustmentSaga,
	);
}
// ========== CREATE LEAVE ADJUSTMENT SAGA END ==========

export function* leaveAdjustmentSagaDetails() {
	yield all([
		call(onGetEmployeeLeaveBalanceStart),
		call(onCreateLeaveAdjustmentStart),
	]);
}

